import React from "react";

import api from "lib/api";
import TasksTable from "./TasksTable";

interface Props {
	search: string;
}

const Completed = ({ search }: Props) => {
	return (
		<TasksTable
			search={search}
			requestTasks={api.workflow.getCompletedTasksAsAdmin}
		/>
	);
};

export default Completed;
